/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VirksomhedDto as OkEgisServiceModelsDtoVirksomhedDto } from '../models/OK/Egis/Service/Models/DTO/virksomhed-dto';

@Injectable({
  providedIn: 'root',
})
export class VirksomhedService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation searchVirksomhed
   */
  static readonly SearchVirksomhedPath = '/api/v1/Virksomhed';

  /**
   * Search in cvr for a company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchVirksomhed()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchVirksomhed$Response(params: {
    searchQuery?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoVirksomhedDto>> {

    const rb = new RequestBuilder(this.rootUrl, VirksomhedService.SearchVirksomhedPath, 'get');
    if (params) {
      rb.query('searchQuery', params.searchQuery, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoVirksomhedDto>;
      })
    );
  }

  /**
   * Search in cvr for a company.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchVirksomhed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchVirksomhed(params: {
    searchQuery?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoVirksomhedDto> {

    return this.searchVirksomhed$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoVirksomhedDto>) => r.body as OkEgisServiceModelsDtoVirksomhedDto)
    );
  }

}
